// Simple client-side admin auth helper (localStorage)
export function isAdminAuthed() {
  return localStorage.getItem("admin_authed") === "true";
}

export function loginAdmin() {
  localStorage.setItem("admin_authed", "true");
}

export function logoutAdmin() {
  localStorage.removeItem("admin_authed");
}

// For convenience - read env values (embedded at build time)
export const ADMIN_EMAIL = process.env.REACT_APP_ADMIN_EMAIL || "";
export const ADMIN_PASSWORD = process.env.REACT_APP_ADMIN_PASSWORD || "";
